import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import './takeoffEstimateWorkspace.css';

const ROLE_SHORT = { Maint: 'Maint', Arborist: 'Arborist', Herbicide: 'Herbicide', Irrigation: 'Irrigation' };

const fmtCurrency = (n) => {
  if (n === null || n === undefined) return '—';
  const v = Number(n);
  if (!Number.isFinite(v)) return '—';
  return v.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
};

const TierCard = ({ tier, estimateId }) => {
  const dashIfMissing = (v) => (Number.isFinite(Number(v)) ? fmtCurrency(v) : '—');
  return (
    <div className={`te-tier ${tier.recommended ? 'featured' : ''}`}>
      <div className="tname">
        {tier.name}
        {tier.recommended && <span className="badge">Recommended</span>}
      </div>
      <div className="price" data-testid={`tier-annual-${estimateId}-${tier.id}`}>
        {dashIfMissing(tier.annualPrice)}
        <span className="ann">annual</span>
      </div>
      <div className="mo"><b>{dashIfMissing(tier.monthlyPrice)}</b> /mo</div>
      <div className="knobs">
        <div className="knob">Margin <span className="val readonly">{tier.marginPct ?? '—'}%</span></div>
        <div className="knob">Rates <span className="val readonly">Default</span></div>
      </div>
      <div className="incl">
        {['Maint', 'Arborist', 'Herbicide', 'Irrigation'].map(role => (
          <span
            key={role}
            className={`chip ${(tier.includedServices || []).includes(role) ? '' : 'off'}`}
          >
            {ROLE_SHORT[role]}
          </span>
        ))}
      </div>
    </div>
  );
};

const TierComparisonPreview = () => {
  const { id } = useParams();
  const [estimate, setEstimate] = useState(null);
  const [status, setStatus] = useState('loading'); // 'loading' | 'ok' | 'not-found' | 'error'

  useEffect(() => {
    let cancelled = false;
    axios.get(`/api/proposal/takeoff-estimate/${id}`)
      .then(resp => { if (!cancelled) { setEstimate(resp.data); setStatus('ok'); } })
      .catch(err => {
        if (cancelled) return;
        setStatus(err?.response?.status === 404 ? 'not-found' : 'error');
      });
    return () => { cancelled = true; };
  }, [id]);

  if (status === 'loading') return <div className="te-preview-loading">Loading…</div>;
  if (status === 'not-found') return <div className="te-preview-empty">Estimate not found</div>;
  if (status === 'error') return <div className="te-preview-empty">Could not load estimate</div>;

  const tiers = estimate?.tiers || [];

  return (
    <div className="te-preview-page">
      <div className="te-preview-grid">
        {tiers.map(tier => (
          <TierCard key={tier.id} tier={tier} estimateId={estimate._id} />
        ))}
      </div>
    </div>
  );
};

export default TierComparisonPreview;
